export class BinanceWithdraw {
    public walletId: number;
    public user: string;
    public transactionId: number;
    public binanceTransactionId: number;
    public apiMessage: string;
    public isClose:boolean;
    public amount:number;
    public isSendToBinance:boolean;
    public date:string;
    public linkTrHash:string;
    public tokenName:string;
    public status:string;
    public amountByTranz:string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/binanceWithdraw.model.ts